<ng-container *ngIf="!!warehouse">
  <table class="table table-compact" *ngIf="warehouse.length > 0">
    <thead>
    <tr>
      <th class="left">Datum</th>
      <th class="left">Anzahl</th>
    </tr>
    </thead>
    <tbody>
    <ng-container *ngFor="let positions of warehouse">
      <tr *ngIf="isIncoming(positions.movement_type)">
        <td class="left">{{ positions.date | date: 'dd.MM.yyyy' }}</td>
        <td class="right">{{ positions.number_of_pieces }}</td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</ng-container>
